import { render, staticRenderFns } from "./OrganisationSelector.vue?vue&type=template&id=6cd92d8e&scoped=true"
import script from "./OrganisationSelector.vue?vue&type=script&lang=js"
export * from "./OrganisationSelector.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSelector.vue?vue&type=style&index=0&id=6cd92d8e&prod&lang=scss"
import style1 from "./OrganisationSelector.vue?vue&type=style&index=1&id=6cd92d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd92d8e",
  null
  
)

export default component.exports